export const BASENAME = process.env.PUBLIC_URL; // in production change to '/reviewer';
export const GENED_ID = 'N7tTtKzCTrd4PDejS7qv';